import React, { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { PageLayout } from 'components/generics/PageLayout';
import { TableAgentes } from './components/TableAgentes';
import { BannerInfoAgentes } from './components/BannerInfoAgentes';
// import { hasPemissions } from '../../../../commons/utils';
import { Link } from 'react-router-dom';
import { hasPemissions } from 'commons/utils';

export const Agentes = () => {
  const [canCreate, setCanCreate] = useState(false);

  useEffect(() => {
    canCheckCanCreate();
  }, []);

  const canCheckCanCreate = async () => {
    const havePermissions = await hasPemissions('modulo.inteligencia.artificial', 'modulo.inteligencia.artificial.agentes', 'create');
    setCanCreate(havePermissions);
  }

  return (
    <PageLayout
      title="Gestión de Agentes"
      mainModule="Inteligencia Artificial"
      icon="SmartToy"
      infoAlert="Administración de agentes personalizados con instrucciones e integraciones específicas."
      actionButtons={
        <>
          {canCreate && (
            <Button 
              variant="contained" 
              color="primary" 
              startIcon={<AddIcon />} 
              component={Link}
              to={'/manager/plataforma-ia/agentes/crear'}
              sx={{
                borderRadius: 2,
                px: 3,
                py: 1,
                fontWeight: 600,
                textTransform: 'none',
                boxShadow: '0px 4px 8px -4px rgba(105, 108, 255, 0.42)'
              }}
            >
              Crear Agente
            </Button>
          )}
        </>
      }
    >
      <TableAgentes />
      <BannerInfoAgentes />
    </PageLayout>
  )
}
